<template>
  <n-modal v-bind="$props">
    <!-- prettier-ignore -->
    <Form ref="modalForm" :model="model" :label-width="labelWidth" @submit.native.prevent>
      <Tabs type="card" name="modalLp" :animated="false">
        <TabPane tab="modalLp" name="basic" :label="this.$t('label.basic')" class="n-modal-container">
          <n-row-col2>
            <!-- companyId -->
            <n-field-selection v-model="model.companyId" field-name="companyId" selection-name="company.company" label="company" :error="error.companyId" :disabled="isEdit || disabled" />
            <!-- language -->
            <n-field-enum v-model="model.language" field-name="language" enum-name="Language" label="language" :error="error.language" :disabled="isEdit || disabled" />
          </n-row-col2>
          <n-row-col2>
            <!-- type -->
            <n-field-enum v-model="model.type" label="type" enum-name="LandingPageType" :error="error.type" :disabled="isEdit || disabled" />
            <!-- variant -->
            <n-field-enum v-model="model.variant" field-name="variant" enum-name="LandingPageVariant" :error="error.variant" label="variant" :disabled="disabled" />
          </n-row-col2>
          <n-row-col2>
            <!-- html -->
            <n-field-boolean v-model="model.html" label="html" :error="error.html" :disabled="disabled" />
            <!-- layout -->
            <n-field-enum v-model="model.layout" label="layout" enum-name="LandingPageLayout" :error="error.layout" :disabled="disabled" />
          </n-row-col2>
          <n-row-col2>
            <!-- discountEnabled -->
            <n-field-boolean v-model="model.discountEnabled" label="discountEnabled" :error="error.discountEnabled" :disabled="disabled" />
            <!-- discountPercent -->
            <n-field-percent v-model="model.discountPercent" format="0 %" field-name="discountPercent" :error="error.discountPercent" label="discountPercent" :disabled="disabled" />
          </n-row-col2>
          <n-row-col2>
            <!-- countdownEnabled -->
            <n-field-boolean v-model="model.countdownEnabled" label="countdownEnabled" :error="error.countdownEnabled" :disabled="disabled" />
            <!-- countdownDuration -->
            <n-field-id v-model="model.countdownDuration" field-name="countdownDuration" label="countdownDuration" :error="error.countdownDuration" :disabled="disabled" />
          </n-row-col2>
          <n-row-col2>
            <!-- bottomEnabled -->
            <n-field-boolean v-model="model.bottomEnabled" label="bottomEnabled" :error="error.bottomEnabled" :disabled="disabled" />
            <!-- bottomButtonText -->
            <n-field-text v-model="model.bottomButtonText" field-name="bottomButtonText" label="bottomButtonText" :error="error.bottomButtonText" :disabled="disabled" />
          </n-row-col2>
          <n-row-col2>
            <!-- floatingIconEnabled -->
            <n-field-boolean v-model="model.floatingIconEnabled" label="floatingIconEnabled" :error="error.floatingIconEnabled" :disabled="disabled" />
            <!-- version -->
            <n-field-id v-model="model.version" label="version" disabled />
          </n-row-col2>
        </TabPane>
        <TabPane tab="modalLp" name="lightTheme" :label="this.$t('label.lightTheme')" class="n-modal-container">
          <n-row-col2>
            <!-- bottomBgColorLight -->
            <n-field-text v-model="model.bottomBgColorLight" field-name="bottomBgColorLight" label="bottomBgColorLight" :error="error.bottomBgColorLight" :disabled="disabled" />
            <!-- countdownBgColorLight -->
            <n-field-text v-model="model.countdownBgColorLight" field-name="countdownBgColorLight" label="countdownBgColorLight" :error="error.countdownBgColorLight" :disabled="disabled" />
          </n-row-col2>
          <n-row-col1>
            <!-- discountBgImageLight -->
            <n-field-text v-model="model.discountBgImageLight" field-name="discountBgImageLight" label="discountBgImageLight" :error="error.discountBgImageLight" :disabled="disabled" />
          </n-row-col1>
          <n-row-col1>
            <!-- backgroundImageLight -->
            <n-field-text v-model="model.backgroundImageLight" field-name="backgroundImageLight" label="backgroundImageLight" :error="error.backgroundImageLight" :disabled="disabled" />
          </n-row-col1>
          <n-row-col1>
            <!-- floatingIconImageLight -->
            <n-field-text v-model="model.floatingIconImageLight" field-name="floatingIconImageLight" label="floatingIconImageLight" :error="error.floatingIconImageLight" :disabled="disabled" />
          </n-row-col1>
          <n-row-col2 v-if="model.html">
            <n-field-boolean v-model="model.wysiwygLight" field-name="wysiwygLight" label="wysiwygLight" :error="error.wysiwygLight" :disabled="disabled" />
            <n-field-boolean v-model="model.previewLight" field-name="previewLight" label="previewLight" :error="error.previewLight" :disabled="disabled" />
          </n-row-col2>
          <n-row-col1>
            <!-- contentLight -->
            <n-text-editor v-model="model.contentLight" :editor-height="150" :html="model.html && model.wysiwygLight" field-name="contentLight" label="contentLight" :error="error.contentLight" :disabled="disabled" />
          </n-row-col1>
          <n-row-col1 v-if="model.previewLight && model.html">
            <n-field-preview v-model="model.contentLight" field-name="previewLight" label="previewLight" :error="error.contentLight" :disabled="disabled" />
          </n-row-col1>
        </TabPane>
        <TabPane tab="modalLp" name="darkTheme" :label="this.$t('label.darkTheme')" class="n-modal-container">
          <n-row-col2>
            <!-- bottomBgColorDark -->
            <n-field-text v-model="model.bottomBgColorDark" field-name="bottomBgColorDark" label="bottomBgColorDark" :error="error.bottomBgColorDark" :disabled="disabled" />
            <!-- countdownBgColorDark -->
            <n-field-text v-model="model.countdownBgColorDark" field-name="countdownBgColorDark" label="countdownBgColorDark" :error="error.countdownBgColorDark" :disabled="disabled" />
          </n-row-col2>
          <n-row-col1>
            <!-- discountBgImageDark -->
            <n-field-text v-model="model.discountBgImageDark" field-name="discountBgImageDark" label="discountBgImageDark" :error="error.discountBgImageDark" :disabled="disabled" />
          </n-row-col1>
          <n-row-col1>
            <!-- backgroundImageDark -->
            <n-field-text v-model="model.backgroundImageDark" field-name="backgroundImageDark" label="backgroundImageDark" :error="error.backgroundImageDark" :disabled="disabled" />
          </n-row-col1>
          <n-row-col1>
            <!-- floatingIconImageDark -->
            <n-field-text v-model="model.floatingIconImageDark" field-name="floatingIconImageDark" label="floatingIconImageDark" :error="error.floatingIconImageDark" :disabled="disabled" />
          </n-row-col1>
          <n-row-col2 v-if="model.html">
            <n-field-boolean v-model="model.wysiwygDark" field-name="wysiwygDark" label="wysiwygDark" :error="error.wysiwygDark" :disabled="disabled" />
            <n-field-boolean v-model="model.previewDark" field-name="previewDark" label="previewDark" :error="error.previewDark" :disabled="disabled" />
          </n-row-col2>
          <n-row-col1>
            <!-- contentDark -->
            <n-text-editor v-model="model.contentDark" :editor-height="150" :html="model.html && model.wysiwygDark" field-name="contentDark" label="contentDark" :error="error.contentDark" :disabled="disabled" />
          </n-row-col1>
          <n-row-col1 v-if="model.previewDark && model.html">
            <n-field-preview v-model="model.contentDark" field-name="previewDark" label="previewDark" :error="error.contentDark" :disabled="disabled" />
          </n-row-col1>
        </TabPane>
      </Tabs>
    </Form>
  </n-modal>
</template>
<script>
import NModal from '@/components/common/NModal';
import { validate, add, edit } from '@/api/company/company-lp';

export default NModal.extend({
  name: 'ModalCompanyTranslation',
  components: { NModal },

  methods: {
    doSubmit(model) {
      return this.isEdit ? edit(model) : add(model);
    },

    doValidate(model) {
      return validate(model);
    },
  },
});
</script>
